var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page',{attrs:{"content-mod-class":"d-flex","use-header":false}},[_c('x-error',{attrs:{"code":404,"message":_vm.message,"use-redirect-button":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }